import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";
import './table.css'

const DataTableWithPopup = ({ thirdPartyData, noBottomColumns }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedContent, setSelectedContent] = useState("");
    const [selectedHead, setSelectedHead] = useState("");

    // Function to truncate text and show "See More"
    const truncateText = (text, key, maxLength = 50) => {

        if (!text) return "";

        if (text.length > maxLength) {
            return (
                <>
                    {text.substring(0, maxLength)}...
                    <Button
                        color="link"
                        onClick={() => {
                            setSelectedContent(text);
                            setSelectedHead(key);
                            setModalOpen(true);
                        }}
                        style={{ padding: "0", marginLeft: "5px" }}
                    >
                        See More
                    </Button>
                </>
            );
        }
        return text;
    };

    // Customize table columns
    const modifiedData = {
        ...thirdPartyData,
        rows: thirdPartyData.rows.map((row) => {
            let updatedRow = { ...row };

            // Loop through all keys and apply truncateText to each value
            Object.keys(updatedRow).forEach((key) => {
                updatedRow[key] = truncateText(updatedRow[key], key);
            });

            return updatedRow;
        })
    };

    return (
        <>
            <MDBDataTable
                style={{ overflow: "auto" }}
                responsive
                striped
                noBottomColumns={noBottomColumns}
                data={modifiedData}
            />

            {/* Modal for displaying full content */}
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>{selectedHead}</ModalHeader>
                <ModalBody className="thirdParty_model">{selectedContent}</ModalBody>
            </Modal>
        </>
    );
};

export default DataTableWithPopup;
